// extracted by mini-css-extract-plugin
export var column = "styles-module--column--1df4a";
export var columnHeading = "styles-module--columnHeading--23193";
export var columnImage = "styles-module--columnImage--b8472";
export var columns = "styles-module--columns--5038f";
export var icon = "styles-module--icon--21cc3";
export var link = "styles-module--link--89a2f";
export var subtitle = "styles-module--subtitle--527db";
export var text = "styles-module--text--64fbc";
export var threeColumnsDefault = "styles-module--threeColumnsDefault--24078";
export var title = "styles-module--title--43d86";